<template>
  <div :class="`${el}__result`">
    <div :class="`${el}__resultRow`">
      <div :class="`${el}__resultRowInner`">
        <Copy size="xl" element="div" color="primaryBlue" responsive centered noMargin>
          <Icon
            :class="`${el}__resultIcon ${variant === 0 ? ` ${el}__resultIcon--rotate` : ''}`"
            v-bind="variants[variant].icon"
          />
          {{ variants[variant].headline }}
        </Copy>
        <Headline size="m" :heading="1" responsive noMargin centered>
          {{ $t('careLevelCalculator.register.box.header.1') }}
        </Headline>
        <Headline size="xs" v-if="variant > 0" :heading="6" responsive noMargin centered>
          {{ $t('careLevelCalculator.register.box.header.2') }}
        </Headline>
      </div>
    </div>
    <div v-if="variant > 0" :class="`${el}__box`">
      <Row>
        <Col :xs="12" :l="6" :hasMargin="!$matchMedia.l">
          <div :class="`${el}__boxInner`">
            <div :class="`${el}__boxImage`">
              <Picture
                :img="$t('careLevelCalculator.landingPage.device.v1.image')"
                :width="665"
                :height="390"
                responsive
              />
            </div>
            <Headline :staticClass="`${el}__listHeadline`" color="tertiaryDark" size="xs" centered>
              {{ $t('careLevelCalculator.register.subline') }}
            </Headline>

            <div
              v-for="(item, idx) in $t('careLevelCalculator.register.bullets')"
              :key="`bullet-${idx}`"
            >
              <Divider dotted />
              <UnorderedList
                :class="`${el}__infoUnorderedList`"
                :listItems="[item]"
                iconName="checkbox-circle-line"
                bold
              />
            </div>
            <Divider dotted />
          </div>
        </Col>
        <Col :xs="12" :l="6" :class="`${el}__order-first-mobile`">
          <CareLevelMailForm @sent="setSent" :token="newsletterJWT" />
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import Icon from '@/objects/Icon';
import Divider from '@/objects/Divider';
import Picture from '@/objects/Picture';
import UnorderedList from '@/objects/UnorderedList';
import CareLevelMailForm from '@/components/Forms/CareLevelMailForm';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'RegisterResult',
  props: {
    el: String,
    variant: Number,
    parentLoaded: Boolean,
    newsletterJWT: String,
  },
  components: {
    Copy,
    Headline,
    Icon,
    Divider,
    Picture,
    UnorderedList,
    CareLevelMailForm,
    Row,
    Col,
  },
  data() {
    return {
      variants: [
        {
          icon: {
            name: 'refresh-fill',
            color: 'supportInfo',
          },
          headline: this.$t('careLevelCalculator.register.box.0.headline'),
        },
        {
          icon: {
            name: 'checkbox-circle-fill',
            color: 'supportSuccess',
          },
          headline: this.$t('careLevelCalculator.register.box.1.headline'),
          copy: this.$t('careLevelCalculator.register.box.1.copy'),
        },
        {
          icon: {
            name: 'question-fill',
            color: 'supportWarning',
          },
          headline: this.$t('careLevelCalculator.register.box.2.headline'),
          copy: this.$t('careLevelCalculator.register.box.2.copy'),
        },
        {
          icon: {
            name: 'checkbox-circle-fill',
            color: 'supportSuccess',
          },
          headline: this.$t('careLevelCalculator.register.box.3.headline'),
        },
        {
          icon: {
            name: 'question-fill',
            color: 'supportWarning',
          },
          headline: this.$t('careLevelCalculator.register.box.4.headline'),
          copy: this.$t('careLevelCalculator.register.box.4.copy'),
        },
      ],
    };
  },

  methods: {
    setSent() {
      this.trackClick('_btn-' + this.$t('careLevelCalculator.reducedResult.register.form.cta'));
    },

    trackClick(labelText, element = 'button') {
      const product = 'Pflegegradrechner-End-Content';
      const label = product + labelText;

      createTrackingData(product, label, element);
    },
  },
};
</script>
